export const NotFound = () => {
  return (
    <div className="flex h-full grow flex-col items-center justify-center p-5">
      <div className="text-h2 font-black">Not Found</div>
    </div>
  )
}
